module.exports = __webpack_public_path__ + "static/action-of-the-week.3903db7b.jpg";